module.exports = __webpack_public_path__ + "img/palm-bar.2ad315f3.jpg";